<app-navbar  class="full-width" bgcolor="primary"></app-navbar>